export const childStatusI18nMap: Record<string, string> = {
  WAITING_BUYER_RESP: '等待买家响应',
};
